module.exports = __webpack_public_path__ + "static/other/gameStarball.838fe320.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/gameStarball.json
// module id = 2645
// module chunks = 0